/**
 * Simple markdown parser for comments
 * Supports: **bold**, *italic*, `code`, and line breaks
 * Also preserves @mention formatting
 */
export function parseMarkdown(text) {
  if (!text) return '';

  let result = text
    // Escape HTML to prevent XSS
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    // Bold: **text**
    .replace(/\*\*(.+?)\*\*/g, '<strong>$1</strong>')
    // Italic: *text*
    .replace(/\*(.+?)\*/g, '<em>$1</em>')
    // Inline code: `text`
    .replace(/`(.+?)`/g, '<code style="background-color: rgba(0,0,0,0.05); padding: 2px 6px; border-radius: 4px; font-family: monospace;">$1</code>')
    // URLs: automatically link them
    .replace(/(https?:\/\/[^\s]+)/g, '<a href="$1" target="_blank" rel="noopener noreferrer" style="color: #1e3a5f;">$1</a>')
    // @mentions: highlight them (format from react-mentions: @[Name](id))
    .replace(/@\[([^\]]+)\]\(\d+\)/g, '<span style="background-color: #e3f2fd; color: #1565c0; padding: 1px 4px; border-radius: 4px; font-weight: 500;">@$1</span>')
    // Line breaks
    .replace(/\n/g, '<br />');

  return result;
}

/**
 * Strip markdown formatting for plain text display
 */
export function stripMarkdown(text) {
  if (!text) return '';

  return text
    .replace(/\*\*(.+?)\*\*/g, '$1')
    .replace(/\*(.+?)\*/g, '$1')
    .replace(/`(.+?)`/g, '$1')
    .replace(/@\[([^\]]+)\]\(\d+\)/g, '@$1');
}

/**
 * Extract mentioned user IDs from comment text
 * Returns array of user IDs
 */
export function extractMentions(text) {
  if (!text) return [];

  const mentionRegex = /@\[([^\]]+)\]\((\d+)\)/g;
  const mentions = [];
  let match;

  while ((match = mentionRegex.exec(text)) !== null) {
    mentions.push({
      name: match[1],
      userId: parseInt(match[2], 10)
    });
  }

  return mentions;
}
